import React from 'react'
import '../css/featured.css'
import YouMayLike from '../featured/YouMayLike'
import Navbar from '../Navbar'
import ScrollToTop from '../ScrollToTop'
  
export const Article5 = () => {
  return (
    <>
    <Navbar/>
    <div className="featured-con">
  <div className="layout">
    <h1 className="article-title">
      The Artist Turned HR Leader: Esi Mmirba Wilson's Blueprint for HR
      Excellence
    </h1>
    <div className="article-category">
      Africa's 10 Most Influential Women Leaders to Watch in 2024
    </div>
    <div className="share-container">
      <div className="share-buttons">
        <button className="share-button linkedin">LinkedIn</button>
        <button className="share-button twitter">Twitter</button>
        <button className="share-button facebook">Facebook</button>
      </div>
    </div>
    <div className="article-image-container">
      <img
        src="./images/COVER.png"
        alt="Professional woman at desk"
        className="article-image"
      />
      <div className="article-image-caption">
        Esi Mmirba Wilson | Director, People and Transformation | Consolidated
        Bank Ghana
      </div>
    </div>
    {/* Article Content */}
    <div className="article-content">
      <p>
        Much like a sculptor Lorem ipsum dolor sit amet consectetur adipisicing
        elit. Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500
        molesMuch like a sculptor Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Dolorem sequi cupiditate labore ipsa sint cumque
        lorem+*500 molestias hic inventore maxime in et,Much like a sculptor
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem sequi
        cupiditate labore ipsa sint cumque lorem+*500 molestias hic inventore
        maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa sint
        cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like a
        sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime iMuch like a
        sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et,Much like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like
        a sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like
        a sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime iMuch like a sculptor Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa sint
        cumque lorem+*500 molestias hic inventore maxime in et,Much like a
        sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like
        a sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime iMuch like a
        sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et,Much like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like
        a sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like
        a sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime iMuch like a sculptor Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa sint
        cumque lorem+*500 molestias hic inventore maxime in et,Much like a
        sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like
        a sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime itias hic
        inventore maxime in et,Much like a sculptor Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa sint
        cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like a
        sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iuMuch like a sculptor Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Dolorem sequi cupiditate labore ipsa
        sint cumque lorem+*500 molestias hic inventore maxime in et, iuMuch like
        a sculptor Lorem ipsum dolor sit amet consectetur adipisicing elit.
        Dolorem sequi cupiditate labore ipsa sint cumque lorem+*500 molestias
        hic inventore maxime in et, iu iure nesciunt magnam consequatur quisquam
        eum earum harum voluptate!chisels away at a block of stone, Esi Mmirba
        Wilson, Director of People and Transformation at Consolidated Bank Ghana
        (CBG), has carved out a distinguished career from the most unlikely of
        beginnings. Surprisingly, she didn't start in HR. Her professional
        journey began in graphic design, where creativity flowed through every
        project. Yet, as any true artist knows, the canvas of life often reveals
        unexpected patterns.
      </p>
    </div>
  </div>
  <div className="popular">
    <div className="sub-articles">
      <div className="sub-article">
        <img
          src="./images/sr3.png"
          alt="Cloud Computing"
        />
        <p>
          The Next Level Cloud Computiud Computing Treud Computing Trend
          Computind Computing Trends in 2025
        </p>
      </div>
      <div className="sub-article">
        <img
          src="./images/sr3.png"
          alt="Healthcare"
        />
        <p>
          The Next Level Cloud Computiud Computing Treud Computing Trend
          Computind Computing Trends in 2025
        </p>
      </div>
      <div className="sub-article">
        <img
          src="./images/sr3.png"
          alt="Myths Busted"
        />
        <p>
          The Next Level Cloud Computiud Computing Treud Computing Trend
          Computind Computing Trends in 2025
        </p>
      </div>
      <div className="sub-article">
        <img
          src="./images/sr3.png"
          alt="Cloud Computing"
        />
        <p>
          The Next Level Cloud Computiud Computing Treud Computing Trend
          Computind Computing Trends in 2025
        </p>
      </div>
      <div className="sub-article">
        <img
          src="./images/sr3.png"
          alt="Healthcare"
        />
        <p>
          The Next Level Cloud Computiud Computing Treud Computing Trend
          Computind Computing Trends in 2025
        </p>
      </div>
    </div>
  </div>
</div>
<ScrollToTop/>
<YouMayLike/>
    </>
  )
}



